<!--统计报表-油烟减排统计-->
<template>
  <section>
    <!-- 工具条 -->
    <el-col :span='24' class='toolbar' style='padding-bottom: 0px;'>
      <el-form :inline='true' :model='filter' size="mini">
        <el-form-item>
          <el-cascader
            v-model="filter.owner"
            placeholder="所属单位"
            :options="customerTree"
            :props="orgProps"
            @change="handleFilterChange"
            clearable
            filterable/>
        </el-form-item>
         <el-form-item>
          <el-date-picker
              v-model="filter.peorid"
              type="daterange"
              @change="handleFilterChange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' @click='handleFilterChange'>查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!-- 列表 -->
    <el-col :span='24'>
      <el-table :data='datalist' show-summary size='mini' border highlight-current-row v-loading='loading'
                :max-height='clientHeight' style='width: 100%'>
        <el-table-column type='index' label='#' align='center' width='55'/>
        <el-table-column prop='name' label='监测点' show-overflow-tooltip width='260'
                         header-align='center'/>
        <el-table-column prop='addr' label='安装地址' show-overflow-tooltip width='260'
                         header-align='center'/>
        <el-table-column prop='mn' label='设备编码' show-overflow-tooltip width='180' align='center'
                         header-align='center'/>
        <el-table-column prop='pm25' label='PM2.5减排量(g)' align='center' header-align='center'/>
        <el-table-column prop='pm10' label='PM10减排量(g)' align='center' header-align='center'/>
        <el-table-column prop='emissions' label='油烟减排量(g)' align='center' header-align='center'/>
        <el-table-column prop='vocs' label='非甲烷减排量(g)' align='center' header-align='center'/>
      </el-table>
    </el-col>

    <!-- 工具条 -->
    <el-col :span='24' class='toolbar'>
      <el-pagination
          background
          @size-change="(v)=>handlePageChange(v, 'size')"
          @current-change="(v)=>handlePageChange(v, 'page')"
          :current-page.sync='filter.page'
          :page-sizes='filter.pageSizes' layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          style='display:inline-block;margin-left:15px'>
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import {getUserInfo, join, ownerJoin} from '@/util'
import dayjs from "dayjs";

export default {
  data() {
    return {
      changeState: false,
      loading: false,
      datalist: [],
      total: 0,
      filter: {
        peorid: null,
        owner: null,
        page: 1,
        size: 20,
        pageSizes: [20, 30, 50]
      },
    }
  },
  computed: {
    ...mapState(['props', 'customerTree', 'clientHeight']),
    ...mapState({
      orgProps: state => Object.assign({}, state.props, {label: 'Org', checkStrictly: true})
    })
  },
  mounted() {
    this.getData()
  },
  methods: {
    hasChange() {
      this.changeState = true
    },
    // 新增方法：处理筛选条件变化
    handleFilterChange() {
      // 筛选条件变化时，重置页码到第一页
      this.filter.page = 1;
      this.getData();
    },
    getData() {
      this.datalist = []
      this.count = 0
      this.loading = true
      let userInfo = getUserInfo().Info
      const param = {
        page: this.filter.page,
        size: this.filter.size,
      }
      if (this.filter.owner && this.filter.owner.length > 0) {
        param.owner = `${ownerJoin(this.filter.owner, userInfo)}`
      }
      if (this.filter.peorid) {
        param.start_at = dayjs(this.filter.peorid[0]).unix()
        param.end_at = dayjs(this.filter.peorid[1]).hour(23).minute(59).second(59).unix()
      }
      this.$get("admin/locale_reduce_total", param).then(res => {
        this.datalist = res.list
        this.total = res.count
        this.$forceUpdate()
      })
      this.loading = false
    },
    // 改变页容量
    selsChange(sels) {
      this.sels = sels
    },
    handlePageChange(val, field) {
      this.filter[field] = val
      this.getData()
    },
  }
}
</script>
